module.exports = __webpack_public_path__ + "static/media/approach-people-recruitment.df1f2ada.png";